import { SET_USER, SET_USERS } from "../../constants/userConstants";

export const setUser = (user) => {
  return {
    type: SET_USER,
    user,
  };
};

export const setUsers = (users, filtered = false) => {
  return {
    type: SET_USERS,
    users,
    filtered,
  };
};
